import angular from 'angular';
import payrollDetailsComponent from './payroll-details.component';

let payrollDetailsModule = angular.module('payrollDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('payrollDetails', payrollDetailsComponent);

export default payrollDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll-details/payroll-details.js